module.exports = __webpack_public_path__ + "static/img/default.55369485.jpg";